<template>
    <div class="vue-location-set" :id="`${character}-location-set`">
        <div class="row">
            <div class="col-lg-2">
                <h3 class="character mb-4">{{ character }}</h3>
            </div>

            <div class="col-lg-10">
                <div class="row">
                    <div class="col-12 col-sm-6 col-lg-4" v-for="location in sortedLocations">
                        <a :href="location.url">{{ location.place }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LocationSet",

    props: {
        locationSet: {},
        character: {}
    },

    computed: {
        sortedLocations() {
            return lodash.sortBy(this.locationSet, ['place'])
        }
    }
}
</script>